module.exports = __webpack_public_path__ + "static/media/normon@2x.64d50200.jpg";